import { render, staticRenderFns } from "./ScoreRule.vue?vue&type=template&id=5488530c&scoped=true&"
import script from "./ScoreRule.vue?vue&type=script&lang=js&"
export * from "./ScoreRule.vue?vue&type=script&lang=js&"
import style0 from "./ScoreRule.vue?vue&type=style&index=0&id=5488530c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488530c",
  null
  
)

export default component.exports